<template>
	<ValidationProvider :vid="vid" :name="name" :rules="rules" v-slot="{ errors, field }">
		<v-text-field type="number" :label="name" :value="innerValue" @change="(value) => (innerValue = $functions.validateInputPrice(value, vid))" :error-messages="errors" prefix="€" :disabled="disabled"></v-text-field>
	</ValidationProvider>
</template>

<script>
export default {
	data: () => ({
		innerValue: null,
		nochangeemitted: false,
	}),
	props: {
		value: {
			type: [String, Number],
			default: null,
		},
		vid: {
			type: String,
			default: null,
		},
		name: {
			type: String,
			default: null,
		},
		rules: {
			type: String,
			default: null,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	methods: {},
	computed: {},
	watch: {
		innerValue(newVal) {
			this.$emit("input", newVal);
			this.$nextTick(() => {
				if (!this.nochangeemitted) {
					this.$emit("change", newVal);
				}
				this.nochangeemitted = false;
			});
		},
		value(newVal) {
			this.innerValue = _.cloneDeep(newVal);
		},
	},
	created() {
		if (this.value != undefined) {
			this.nochangeemitted = true;
			this.innerValue = _.cloneDeep(this.value);
		}
	},
	beforeDestroy() {
		this.nochangeemitted = true;
		this.$emit("input", null);
		this.innerValue = null;
	},
};
</script>
